const routes = [
  {
    path: "/manutencao-motivo-afastamento",
    name: "manutencao-motivo-afastamento",
    meta: {
      allowedPermissions: ["motivo_afastamento_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoAfastamento/ManutencaoMotivoAfastamentoHome.vue"
      ),
  },
  {
    path: "/manutencao-motivo-afastamento/novo",
    name: "manutencao-motivo-afastamento-novo",
    meta: {
      allowedPermissions: ["motivo_afastamento_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoAfastamento/ManutencaoMotivoAfastamentoCad.vue"
      ),
  },
  {
    path: "/manutencao-motivo-afastamento/editar/:id",
    name: "manutencao-motivo-afastamento-editar",
    meta: {
      allowedPermissions: ["motivo_afastamento_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoAfastamento/ManutencaoMotivoAfastamentoEdit.vue"
      ),
  },
];

export default routes;
